import React from 'react';
import styled from 'styled-components';

const TitleContainer = styled.div`
    ${({sm, main}) => {
        if (sm) {
            return `
                color: var(--default-text-color);
                font-size: var(--text-size-small);
                font-weight: 800;
            `;
        } else if (main) {
            return `
                color: var(--default-text-color);
                font-size: calc(var(--text-size-small) * 2 );
                font-weight: 600;
            `;
        } else {
            return '';
        }
    }}
`;
const Title = ({children, main, sub, sm}) => (
    <>
        {/* Needs to be applied  */}
        {main && (
            <TitleContainer main={main}>
                {main} {children}
            </TitleContainer>
        )}{' '}
        {/* Needs to be applied  */}
        {sub && (
            <TitleContainer sub={sub}>
                {sub} {children}
            </TitleContainer>
        )}{' '}
        {sm && (
            <TitleContainer sm={sm}>
                {sm} {children}
            </TitleContainer>
        )}
    </>
);

export const MutedParagraph = styled.p`
    color: var(--label-text-color);
`;

export {Title, TitleContainer};
